import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { fetchAuthSession } from '@aws-amplify/auth';
import { UserState } from 'app/state-management/user-state';
import { from, lastValueFrom } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private userState: UserState) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return from(this.handle(req, next));
  }

  async handle(req: HttpRequest<any>, next: HttpHandler) {
    // Get the auth token from the service.
    let res = await fetchAuthSession();
    let authReq: HttpRequest<any>;
    if (res.tokens?.idToken?.toString()) {
      try {
        authReq = req.clone({
          headers: req.headers.set('Authorization', res.tokens?.idToken?.toString()),
        });
      } catch (error) {
        console.error(error);
        authReq = req.clone();
      }
    } else {
      this.userState.setIsLogin(false);
      authReq = req.clone();
    }

    // send cloned request with header to the next handler.
    return lastValueFrom(next.handle(authReq));
  }
}
